/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { DashboardContext, emptyDashboardData } from './DashboardContext';
import RegisterTab from './RegisterTab';
import InProgressTab from './InProgressTab';
import CompleteTab from './CompleteTab';
import { coursePageQuizScore, studentDashboard } from 'dsoapi';
const REGISTER = 'REGISTER';
const IN_PROGRESS = 'IN_PROGRESS';
const COMPLETE = 'COMPLETE';

const Dashboard = ({ setTitle = () => {}, site, children }) => {
  const [dashboardData, setDashboardData] = useState(emptyDashboardData);
  const [passedQuizMessage, setPassedQuizMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const { '*': selectedTab } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const quizScoreFrom = queryParams.get('quizScoreFrom');

  const navigate = useNavigate();

  setTitle('Dashboard');

  useEffect(() => {
    const fetchDashboardData = async () => {
      setIsLoading(true);
      const response = await studentDashboard();
      setDashboardData(response.data);
      setIsLoading(false);
    };
    fetchDashboardData();
  }, []);

  useEffect(() => {
    const fetchQuizScore = async () => {
      const {
        data: { score },
      } = await coursePageQuizScore(quizScoreFrom);
      if (score) {
        let message = `Congratulations you have passed your exam with a score of ${score}%.  `;
        message += 'You may download your certificate below.';
        setPassedQuizMessage(message);
      }
    };
    if (quizScoreFrom) {
      fetchQuizScore();
    }
  }, [quizScoreFrom]);

  useEffect(() => {
    if (!dashboardData.activeTab && !isLoading) {
      const initialActiveTab = () => {
        if (selectedTab) {
          switch (selectedTab.toUpperCase()) {
            case REGISTER:
              return REGISTER;
            case IN_PROGRESS:
              return IN_PROGRESS;
            case COMPLETE:
              return COMPLETE;
            default:
              return REGISTER;
          }
        }
        if (dashboardData.registrationInProgress.length > 0) {
          return REGISTER;
        }
        if (dashboardData.enrolled.length > 0) {
          return IN_PROGRESS;
        }
        if (dashboardData.completed.length > 0) {
          return COMPLETE;
        }
        return REGISTER;
      };
      setDashboardData((prev) => ({ ...prev, activeTab: initialActiveTab() }));
    }
  }, [
    selectedTab,
    dashboardData.registrationInProgress.length,
    dashboardData.enrolled.length,
    dashboardData.completed.length,
    dashboardData.activeTab,
    isLoading,
  ]);

  const setActiveTabAndUrl = (tab) => {
    setDashboardData((prev) => ({ ...prev, activeTab: tab }));
    window.history.pushState(null, '', `/dashboard/${tab.toLowerCase()}`);
  };

  const anyDashboardRecords = () => {
    const dashboardRecordCount =
      dashboardData.registrationInProgress.length +
      dashboardData.enrolled.length +
      dashboardData.completed.length;
    return dashboardRecordCount > 0;
  };

  return (
    <>
      <div className="ui main container">
        {passedQuizMessage && (
          <div style={{ textAlign: 'center' }}>
            <h3>{passedQuizMessage}</h3>
          </div>
        )}
        <div className="ui three item menu">
          <a
            className={`item${
              dashboardData.activeTab === REGISTER ? ' active' : ''
            }`}
            onClick={() => setActiveTabAndUrl(REGISTER)}
          >
            Register
          </a>
          <a
            className={`item${
              dashboardData.activeTab === IN_PROGRESS ? ' active' : ''
            }`}
            onClick={() => setActiveTabAndUrl(IN_PROGRESS)}
          >
            In Progress
          </a>
          <a
            className={`item${
              dashboardData.activeTab === COMPLETE ? ' active' : ''
            }`}
            onClick={() => setActiveTabAndUrl(COMPLETE)}
          >
            Complete
          </a>
        </div>
        {dashboardData.activeTab === REGISTER && (
          <RegisterTab
            courses={dashboardData.registrationInProgress}
            anyDashboardRecords={anyDashboardRecords()}
            site={site}
            onReEnrollClick={
              site === 'FEDS'
                ? () => setActiveTabAndUrl(REGISTER)
                : () => navigate('/')
            }
          />
        )}
        {dashboardData.activeTab === IN_PROGRESS && (
          <InProgressTab courses={dashboardData.enrolled} />
        )}
        {dashboardData.activeTab === COMPLETE && (
          <CompleteTab
            courses={dashboardData.completed}
            anyDashboardRecords={anyDashboardRecords()}
            onReEnrollClick={
              site === 'FEDS'
                ? () => setActiveTabAndUrl(REGISTER)
                : () => navigate('/')
            }
          />
        )}
        <DashboardContext.Provider value={dashboardData}>
          {!isLoading && children}
        </DashboardContext.Provider>
      </div>
    </>
  );
};

export default Dashboard;
